export default "__VITE_ASSET__DzOPacCd__"